import type { NoteCategory } from "../types/lead.types.ts"

/**
 * Mirrors `LeadNote.category` in `ezbuild_back`. There is no codegen between
 * the repos, so this is hand-copied — order drives the Add/Edit Note modal's
 * Select options, and `note-categories.test.ts` pins the full value set so a
 * backend addition/removal fails here rather than in QA.
 */
const NOTE_CATEGORIES: NoteCategory[] = [
  "general",
  "customer",
  "follow_up",
  "proposal",
  "opportunity",
  "internal"
]

export { NOTE_CATEGORIES }
